module.exports = __webpack_public_path__ + "img/renew2x.png?18b6bf301be7443af2ae7ecc79dcb7a5";